// import './App.css';
import { useEffect, useState } from "react";
import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
} from "@material-ui/core";

import { getAssessments } from "./../services/api";
import { FaEdit, FaRegTrashAlt } from "react-icons/fa";

function AnswersTable({ answers, onEdit, onDelete }) {
  function editAnswer(id) {
    console.log("edit assessment", id);
  }

  if (!answers) {
    return <span>wtf1</span>;
  }

  return (
    <div className="sectionsTable">
      <Button
        variant="contained"
        color="primary"
        className="btn-main-limber mb-15"
        onClick={() => {
          onEdit({});
        }}
      >
        Create Answer
      </Button>
      <TableContainer
        component={Paper}
        style={{
          overflow: "auto",
          height: "95%",
        }}
      >
        <Table stickyHeader sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>Id</TableCell>
              <TableCell align="right">Text</TableCell>
              <TableCell align="right">Order</TableCell>
              <TableCell align="right">Target</TableCell>
              <TableCell align="right">Edit</TableCell>
              <TableCell align="right">Delete</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {answers.map((answer) => (
              <TableRow key={answer.id} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                <TableCell component="th" scope="row">
                  {answer.id}
                </TableCell>
                <TableCell align="right">{answer.answerTRs.length && answer.answerTRs[0].text}</TableCell>
                <TableCell align="right">{answer.order}</TableCell>
                <TableCell align="right">{answer.target}</TableCell>
                <TableCell align="right">
                  <FaEdit
                    className="icon-limber"
                    size="1.5em"
                    onClick={(event) => {
                      onEdit(answer);
                    }}
                  />
                </TableCell>
                <TableCell align="right">
                  <FaRegTrashAlt className="icon-limber" size="1.5em" onClick={() => onDelete(answer)} />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}

export default AnswersTable;
